import { HttpClient } from '@angular/common/http'
import { Injectable, inject } from '@angular/core'
import { environment } from 'src/environments/environment'
import { AuditPhoto, H2HPhoto } from '../types/photo'
import { EMPTY, catchError, Observable } from 'rxjs'

@Injectable({
  providedIn: 'root',
})
export class PhotoService {
  private API_BASE_URL = environment.apiBaseUrl
  private http = inject(HttpClient)

  createPhoto(photos: FormPhoto[], objType: PhotoObjType, objId: string) {
    // create multi-part form with image
    const formData: FormData = new FormData()
    photos.forEach((photo) => {
      const [name, blob] = photo
      formData.append(name, blob)
    })

    formData.append('objType', objType)
    formData.append('objId', objId)

    return this.http
      .post<H2HPhoto[]>(`${this.API_BASE_URL}/photo`, formData)
      .pipe(
        catchError((err) => {
          console.error('createPhoto error', err)
          // Don't return EMPTY - let the error bubble up so the UI can handle it
          // This prevents pets from being created without photos when upload fails
          throw err
        }),
      )
  }

  searchPhotos(body: SearchPhotosBody = {}) {
    return this.http.post<H2HPhoto[]>(`${this.API_BASE_URL}/photo/search`, body)
  }

  deletePhoto(photoId: string) {
    return this.http.delete(`${this.API_BASE_URL}/photo/${photoId}`)
  }
  auditPhoto(photoId: string): Observable<AuditPhoto[]> {
    return this.http.get(
      `${this.API_BASE_URL}/photo/${photoId}/audit`,
    ) as Observable<AuditPhoto[]>
  }
}

export type PhotoObjType = 'PET' | 'SHELTER' | 'SHELTER_HERO'

export type FormPhoto = [string, Blob]

export type SearchPhotosBody = {
  creatorUuid?: string
  objType?: PhotoObjType
  objId?: string
}
